import React, { useState, useEffect } from 'react';
import { MdExitToApp, MdHelp } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import Icon, { MenuOutlined } from '@ant-design/icons';
import { Menu, PageHeader, Button } from 'antd';
import { toast } from 'react-toastify';
import NotificationSettings from './NotificationSettings';
import request from '../../../logic/utils/request';
import cleanLocalStorage from '../../../logic/utils/cleanLocalStorage';

function Header(props) {
  const {
    showNotifications,
    setShowNotifications,
    notificationInterval,
    setNotificationInterval,
    onBurgerClick,
  } = props;
  const [isMobile, setIsMobile] = useState(false);
  const officeName = localStorage.getItem('officeName');
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleLogout = async () => {
    try {
      await request('/server/api/logout/');
      cleanLocalStorage();
      navigate('/login');
    } catch (e) {
      toast.warn('Ошибка');
    }
  };

  const fio = window.localStorage.getItem('fio');

  return (
    <PageHeader
      title={(
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {isMobile && onBurgerClick && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={onBurgerClick}
              size="large"
              style={{
                color: '#1890ff',
                padding: '8px 12px',
                height: 'auto',
                backgroundColor: '#f0f9ff',
                border: '1px solid #d1ecf1',
                borderRadius: '6px',
                fontSize: '18px',
              }}
            />
          )}
          <span>{officeName}</span>
        </div>
      )}
      extra={(
        <div style={{ minWidth: isMobile ? 'auto' : 450 }}>
          <Menu mode="horizontal">
            <Menu.Item>
              <NotificationSettings
                showNotifications={showNotifications}
                setShowNotifications={setShowNotifications}
                notificationInterval={notificationInterval}
                setNotificationInterval={setNotificationInterval}
              />
            </Menu.Item>
            <Menu.Item
              style={{ fontSize: 16 }}
              icon={<Icon component={MdHelp} style={{ fontSize: 16 }} />}
            >
              <Link to="/about/">
                <span>О системе</span>
              </Link>
            </Menu.Item>

            <Menu.Item style={{ fontSize: 16 }} onClick={handleLogout}>
              <span>{fio}</span>
              <Icon style={{ marginLeft: '10px', fontSize: 16 }} component={MdExitToApp} />
            </Menu.Item>
          </Menu>

        </div>
      )}
    />
  );
}
export default React.memo(Header);
